// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IOcrSuggestedProviderDto } from './IOcrSuggestedProviderDto';
import {
    IOcrSuggestedProviderDtoFromJSON,
    IOcrSuggestedProviderDtoFromJSONTyped,
    IOcrSuggestedProviderDtoToJSON,
    IOcrSuggestedProviderDtoToJSONTyped,
} from './IOcrSuggestedProviderDto';
import type { IOcrServiceForOptionDto } from './IOcrServiceForOptionDto';
import {
    IOcrServiceForOptionDtoFromJSON,
    IOcrServiceForOptionDtoFromJSONTyped,
    IOcrServiceForOptionDtoToJSON,
    IOcrServiceForOptionDtoToJSONTyped,
} from './IOcrServiceForOptionDto';
import type { IOcrExpenseDto } from './IOcrExpenseDto';
import {
    IOcrExpenseDtoFromJSON,
    IOcrExpenseDtoFromJSONTyped,
    IOcrExpenseDtoToJSON,
    IOcrExpenseDtoToJSONTyped,
} from './IOcrExpenseDto';
import type { IOcrProviderOptionDto } from './IOcrProviderOptionDto';
import {
    IOcrProviderOptionDtoFromJSON,
    IOcrProviderOptionDtoFromJSONTyped,
    IOcrProviderOptionDtoToJSON,
    IOcrProviderOptionDtoToJSONTyped,
} from './IOcrProviderOptionDto';
import type { IOcrDocumentWarningDto } from './IOcrDocumentWarningDto';
import {
    IOcrDocumentWarningDtoFromJSON,
    IOcrDocumentWarningDtoFromJSONTyped,
    IOcrDocumentWarningDtoToJSON,
    IOcrDocumentWarningDtoToJSONTyped,
} from './IOcrDocumentWarningDto';
import type { IOcrAccountOrderDto } from './IOcrAccountOrderDto';
import {
    IOcrAccountOrderDtoFromJSON,
    IOcrAccountOrderDtoFromJSONTyped,
    IOcrAccountOrderDtoToJSON,
    IOcrAccountOrderDtoToJSONTyped,
} from './IOcrAccountOrderDto';
import type { IOcrServiceDateOptionDto } from './IOcrServiceDateOptionDto';
import {
    IOcrServiceDateOptionDtoFromJSON,
    IOcrServiceDateOptionDtoFromJSONTyped,
    IOcrServiceDateOptionDtoToJSON,
    IOcrServiceDateOptionDtoToJSONTyped,
} from './IOcrServiceDateOptionDto';
import type { IOcrServiceOptionDto } from './IOcrServiceOptionDto';
import {
    IOcrServiceOptionDtoFromJSON,
    IOcrServiceOptionDtoFromJSONTyped,
    IOcrServiceOptionDtoToJSON,
    IOcrServiceOptionDtoToJSONTyped,
} from './IOcrServiceOptionDto';
import type { IOcrAddressResponseDto } from './IOcrAddressResponseDto';
import {
    IOcrAddressResponseDtoFromJSON,
    IOcrAddressResponseDtoFromJSONTyped,
    IOcrAddressResponseDtoToJSON,
    IOcrAddressResponseDtoToJSONTyped,
} from './IOcrAddressResponseDto';
import type { IOcrAmountOptionDto } from './IOcrAmountOptionDto';
import {
    IOcrAmountOptionDtoFromJSON,
    IOcrAmountOptionDtoFromJSONTyped,
    IOcrAmountOptionDtoToJSON,
    IOcrAmountOptionDtoToJSONTyped,
} from './IOcrAmountOptionDto';

/**
 * 
 * @export
 * @interface IOcrResultDto
 */
export interface IOcrResultDto {
    /**
     * 
     * @type {IOcrSuggestedProviderDto}
     * @memberof IOcrResultDto
     */
    selected_provider?: IOcrSuggestedProviderDto;
    /**
     * 
     * @type {IOcrServiceForOptionDto}
     * @memberof IOcrResultDto
     */
    selected_service_for?: IOcrServiceForOptionDto;
    /**
     * 
     * @type {IOcrServiceOptionDto}
     * @memberof IOcrResultDto
     */
    selected_service?: IOcrServiceOptionDto;
    /**
     * 
     * @type {IOcrAmountOptionDto}
     * @memberof IOcrResultDto
     */
    selected_amount?: IOcrAmountOptionDto;
    /**
     * 
     * @type {IOcrServiceDateOptionDto}
     * @memberof IOcrResultDto
     */
    selected_service_date?: IOcrServiceDateOptionDto;
    /**
     * 
     * @type {string}
     * @memberof IOcrResultDto
     */
    selected_account_number?: string;
    /**
     * 
     * @type {string}
     * @memberof IOcrResultDto
     */
    selected_invoice_number?: string;
    /**
     * 
     * @type {Array<IOcrProviderOptionDto>}
     * @memberof IOcrResultDto
     */
    providers?: Array<IOcrProviderOptionDto>;
    /**
     * 
     * @type {Array<IOcrAddressResponseDto>}
     * @memberof IOcrResultDto
     */
    address_options?: Array<IOcrAddressResponseDto>;
    /**
     * 
     * @type {Array<IOcrServiceForOptionDto>}
     * @memberof IOcrResultDto
     */
    service_for_options?: Array<IOcrServiceForOptionDto>;
    /**
     * 
     * @type {Array<IOcrServiceOptionDto>}
     * @memberof IOcrResultDto
     */
    service_options?: Array<IOcrServiceOptionDto>;
    /**
     * 
     * @type {Array<IOcrAmountOptionDto>}
     * @memberof IOcrResultDto
     */
    amount_options?: Array<IOcrAmountOptionDto>;
    /**
     * 
     * @type {Array<IOcrServiceDateOptionDto>}
     * @memberof IOcrResultDto
     */
    service_date_options?: Array<IOcrServiceDateOptionDto>;
    /**
     * 
     * @type {Array<IOcrExpenseDto>}
     * @memberof IOcrResultDto
     */
    ineligible_expenses?: Array<IOcrExpenseDto>;
    /**
     * 
     * @type {Array<Array<IOcrAccountOrderDto>>}
     * @memberof IOcrResultDto
     */
    account_orders?: Array<Array<IOcrAccountOrderDto>>;
    /**
     * 
     * @type {boolean}
     * @memberof IOcrResultDto
     */
    is_receipt_required?: boolean;
    /**
     * 
     * @type {Array<IOcrDocumentWarningDto>}
     * @memberof IOcrResultDto
     */
    warnings?: Array<IOcrDocumentWarningDto>;
}

/**
 * Check if a given object implements the IOcrResultDto interface.
 */
export function instanceOfIOcrResultDto(value: object): value is IOcrResultDto {
    return true;
}

export function IOcrResultDtoFromJSON(json: any): IOcrResultDto {
    return IOcrResultDtoFromJSONTyped(json, false);
}

export function IOcrResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOcrResultDto {
    if (json == null) {
        return json;
    }
    return {
        
        'selected_provider': json['selected_provider'] == null ? undefined : IOcrSuggestedProviderDtoFromJSON(json['selected_provider']),
        'selected_service_for': json['selected_service_for'] == null ? undefined : IOcrServiceForOptionDtoFromJSON(json['selected_service_for']),
        'selected_service': json['selected_service'] == null ? undefined : IOcrServiceOptionDtoFromJSON(json['selected_service']),
        'selected_amount': json['selected_amount'] == null ? undefined : IOcrAmountOptionDtoFromJSON(json['selected_amount']),
        'selected_service_date': json['selected_service_date'] == null ? undefined : IOcrServiceDateOptionDtoFromJSON(json['selected_service_date']),
        'selected_account_number': json['selected_account_number'] == null ? undefined : json['selected_account_number'],
        'selected_invoice_number': json['selected_invoice_number'] == null ? undefined : json['selected_invoice_number'],
        'providers': json['providers'] == null ? undefined : ((json['providers'] as Array<any>).map(IOcrProviderOptionDtoFromJSON)),
        'address_options': json['address_options'] == null ? undefined : ((json['address_options'] as Array<any>).map(IOcrAddressResponseDtoFromJSON)),
        'service_for_options': json['service_for_options'] == null ? undefined : ((json['service_for_options'] as Array<any>).map(IOcrServiceForOptionDtoFromJSON)),
        'service_options': json['service_options'] == null ? undefined : ((json['service_options'] as Array<any>).map(IOcrServiceOptionDtoFromJSON)),
        'amount_options': json['amount_options'] == null ? undefined : ((json['amount_options'] as Array<any>).map(IOcrAmountOptionDtoFromJSON)),
        'service_date_options': json['service_date_options'] == null ? undefined : ((json['service_date_options'] as Array<any>).map(IOcrServiceDateOptionDtoFromJSON)),
        'ineligible_expenses': json['ineligible_expenses'] == null ? undefined : ((json['ineligible_expenses'] as Array<any>).map(IOcrExpenseDtoFromJSON)),
        'account_orders': json['account_orders'] == null ? undefined : json['account_orders'],
        'is_receipt_required': json['is_receipt_required'] == null ? undefined : json['is_receipt_required'],
        'warnings': json['warnings'] == null ? undefined : ((json['warnings'] as Array<any>).map(IOcrDocumentWarningDtoFromJSON)),
    };
}

export function IOcrResultDtoToJSON(json: any): IOcrResultDto {
    return IOcrResultDtoToJSONTyped(json, false);
}

export function IOcrResultDtoToJSONTyped(value?: IOcrResultDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'selected_provider': IOcrSuggestedProviderDtoToJSON(value['selected_provider']),
        'selected_service_for': IOcrServiceForOptionDtoToJSON(value['selected_service_for']),
        'selected_service': IOcrServiceOptionDtoToJSON(value['selected_service']),
        'selected_amount': IOcrAmountOptionDtoToJSON(value['selected_amount']),
        'selected_service_date': IOcrServiceDateOptionDtoToJSON(value['selected_service_date']),
        'selected_account_number': value['selected_account_number'],
        'selected_invoice_number': value['selected_invoice_number'],
        'providers': value['providers'] == null ? undefined : ((value['providers'] as Array<any>).map(IOcrProviderOptionDtoToJSON)),
        'address_options': value['address_options'] == null ? undefined : ((value['address_options'] as Array<any>).map(IOcrAddressResponseDtoToJSON)),
        'service_for_options': value['service_for_options'] == null ? undefined : ((value['service_for_options'] as Array<any>).map(IOcrServiceForOptionDtoToJSON)),
        'service_options': value['service_options'] == null ? undefined : ((value['service_options'] as Array<any>).map(IOcrServiceOptionDtoToJSON)),
        'amount_options': value['amount_options'] == null ? undefined : ((value['amount_options'] as Array<any>).map(IOcrAmountOptionDtoToJSON)),
        'service_date_options': value['service_date_options'] == null ? undefined : ((value['service_date_options'] as Array<any>).map(IOcrServiceDateOptionDtoToJSON)),
        'ineligible_expenses': value['ineligible_expenses'] == null ? undefined : ((value['ineligible_expenses'] as Array<any>).map(IOcrExpenseDtoToJSON)),
        'account_orders': value['account_orders'],
        'is_receipt_required': value['is_receipt_required'],
        'warnings': value['warnings'] == null ? undefined : ((value['warnings'] as Array<any>).map(IOcrDocumentWarningDtoToJSON)),
    };
}

